import { TRIGGER_OFFSET_TIMING } from '../../Campaign/constants';

const { AFTER, BEFORE } = TRIGGER_OFFSET_TIMING;

export const DAYS_TO_DELAY_LABEL_TEXT = {
  [AFTER]: 'Days after',
  [BEFORE]: 'Days before',
};
